// Renaissance-style SVG ornaments — fleurons, vine flourishes, columns.
// Inspired by chapter headings in old folios.

export function Flourish({ width = 240, color = "currentColor", className = "" }) {
  return (
    <svg width={width} height="24" viewBox="0 0 240 24" fill="none" className={className} aria-hidden="true">
      <g stroke={color} strokeWidth="0.9" strokeLinecap="round" opacity="0.65">
        <path d="M5 12 H95" />
        <path d="M145 12 H235" />
        <path d="M100 12 c4 -6 12 -6 16 0 c4 6 12 6 16 0" fill="none" />
        <circle cx="120" cy="12" r="2.4" fill={color} />
        <path d="M95 12 c-3 -3 -8 -3 -8 0 c0 3 5 3 8 0 z" fill={color} opacity="0.7"/>
        <path d="M145 12 c3 -3 8 -3 8 0 c0 3 -5 3 -8 0 z" fill={color} opacity="0.7"/>
      </g>
    </svg>
  );
}

export function CornerFlourish({ color = "currentColor", className = "" }) {
  return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" className={className} aria-hidden="true">
      <g stroke={color} strokeWidth="1" fill="none" opacity="0.65">
        <path d="M2 22 c0 -11 9 -20 20 -20" />
        <path d="M2 22 c0 -7 4 -14 10 -17" strokeDasharray="2 2" />
        <circle cx="22" cy="2" r="1.6" fill={color} />
        <circle cx="2" cy="22" r="1.6" fill={color} />
      </g>
    </svg>
  );
}

export function ColumnDivider({ color = "currentColor", className = "" }) {
  return (
    <svg width="14" height="64" viewBox="0 0 14 64" fill="none" className={className} aria-hidden="true">
      <g stroke={color} strokeWidth="0.9" opacity="0.55">
        <line x1="7" y1="4" x2="7" y2="60" />
        <circle cx="7" cy="4" r="2.2" fill={color} />
        <circle cx="7" cy="60" r="2.2" fill={color} />
        <line x1="3" y1="32" x2="11" y2="32" />
      </g>
    </svg>
  );
}

export function Fleuron({ size = 28, color = "currentColor", className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" className={className} aria-hidden="true">
      <g stroke={color} fill={color} opacity="0.8">
        <path d="M14 4 c2 4 4 6 8 6 c-4 0 -6 2 -8 6 c-2 -4 -4 -6 -8 -6 c4 0 6 -2 8 -6 z" strokeWidth="0.6" />
        <path d="M14 14 c2 4 4 6 8 6 c-4 0 -6 2 -8 6 c-2 -4 -4 -6 -8 -6 c4 0 6 -2 8 -6 z" strokeWidth="0.6" fillOpacity="0.5" />
      </g>
    </svg>
  );
}
